<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ (schemeType === 'tdf' || schemeType == 'makeI' || schemeType == 'makeII' || schemeType ==
          'makeIII') ? 'Testing / Trials' : 'User Evaluation Trials' }}</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit">
          <button class="btn btn-primary me-2" (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="commentForm?.invalid">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

       
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- File Upload -->
  <div class="mt-3">
    <!-- <div class="d-flex justify-content-end mt-2 mb-4" *ngIf="schemeType == 'idex'">
      <button pButton type="button" label="Add Row" icon="pi pi-plus" (click)="addRow()" [outlined]="true"
        [disabled]="!isEditable"></button>
    </div> -->
    <div class="overflow-x-auto" *ngIf="schemeType == 'idex'">
      <p-table [value]="vendors" editMode="row" dataKey="trialVendorId" #table>
        <ng-template pTemplate="header">
          <tr>
            <th>Vendor Name</th>
            <th>Upload Doc</th>
            <th
              *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
              Actions
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-editing="editing">
          <tr [pEditableRow]="rowData">
            <td>
              <ng-container *ngIf="editing; else viewVendor">
                <!-- Show dropdown only if vendor is not selected -->
                <ng-container *ngIf="!rowData.vendor; else lockedVendor">
                  <p-dropdown [options]="vendors" optionLabel="vendor.name" optionValue="vendor.id"
                    [(ngModel)]="rowData.vendor.id" placeholder="Select Vendor" [showClear]="true" [filter]="true"
                    appendTo="body" styleClass="w-full">
                  </p-dropdown>
                </ng-container>

                <!-- Vendor is already selected, show plain text (read-only) -->
                <ng-template #lockedVendor>
                  <span>{{rowData.vendorName }}</span>
                </ng-template>
              </ng-container>

              <ng-template #viewVendor>
                <span>{{rowData.vendorName }}</span>
              </ng-template>
            </td>



            <!-- File Upload -->
            <td>
              <ng-container *ngIf="editing; else showFile">
                <input type="file" (change)="onFileUpload($event, rowData)"
                  accept=".pdf, .csv, .docx, .png, .jpg, .jpeg" />
              </ng-container>
              <ng-template #showFile>
                <a *ngIf="rowData.file; else noFile" [href]="apiUrl + rowData.file" target="_blank" class="file-name">
                  {{ rowData.file }}
                </a>
                <ng-template #noFile>No file</ng-template>
              </ng-template>
            </td>

            <!-- Actions -->
            <td
              *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
              <button *ngIf="!editing" pButton icon="pi pi-pencil" (click)="table.initRowEdit(rowData)"
                class="p-button-text"></button>
              <button *ngIf="editing" pButton icon="pi pi-check" (click)="onRowEditSave(rowData)"
                class="p-button-text p-button-success"></button>
              <button *ngIf="editing" pButton icon="pi pi-times" (click)="table.cancelRowEdit(rowData)"
                class="p-button-text p-button-danger"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>
    <app-upload-document [title]="stepDetails.name +  '  Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
    <hr class="my-3" />
    <!-- <div
      *ngIf="schemeType == 'makeI' || schemeType == 'makeII' || schemeType == 'makeIII' || schemeType == 'tdf' || schemeType == 'revenue'">
      <span class="p-card">{{shortlistedvendor?.name || shortlistedvendor?.vendor_name }}</span>
    </div> -->
   

    <!-- <div class="row mb-4 mt-4" *ngIf="schemeType =='rev'">
      <div class="col-lg-8">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">

            <div class="d-flex align-items-center mb-3">
              <i class="pi pi-file text-primary me-2"></i>
              <h5 class="card-title mb-0">
                Upload Prototype Report
              </h5>
            </div>

            <p class="text-muted mb-4">
              Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)
            </p>

            <div class="upload-container mb-4" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || stepDetails?.can_edit ||
              (stepDetails?.step_status != 'approved' && userID == 6)">
              <div class="upload-area p-4 text-center border rounded">
                <p-fileUpload mode="basic" chooseLabel="Browse Files" (uploadHandler)="onUploadRev($event)"
                  [auto]="true" [customUpload]="true" #fileUpload [multiple]="true"
                  [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" [maxFileSize]="209715200"
                  styleClass="p-button-rounded p-button-outlined">
                </p-fileUpload>
              </div>
            </div>

            <div *ngIf="selectedFinalOfferFiles?.length || filesList?.length" class="uploaded-files-list">
              <div *ngFor="let file of selectedFinalOfferFiles; let i = index"
                class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center mb-2">
                <div class="d-flex align-items-center">
                  <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                  <div>
                    <p class="mb-0 fw-semibold">
                      <a href="#" (click)="openFileInNewTab(file)" class="text-decoration-none">
                        {{ getFileName(file.name) }}
                      </a>
                    </p>
                    <small class="text-muted">Uploaded successfully</small>
                  </div>
                </div>
                <button class="btn btn-sm" (click)="removeFile(i)">
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <li *ngFor="let file of filesList" class="d-flex align-items-center mb-2">
                <i class="pi pi-file text-primary me-2"></i>
                <a [href]="apiUrl + file.file" target="_blank" rel="noopener noreferrer">{{ getFileName(file.file)
                  }}</a>
              </li>
            </div>

            <div *ngIf="!selectedFinalOfferFiles?.length &&
          !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender ||  stepDetails?.can_edit ||
          (stepDetails?.step_status != 'approved' && userID == 6))"
              class="no-file-placeholder p-3 text-center bg-light rounded">
              <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
              <p class="mb-0 text-muted">No files uploaded</p>
            </div>
          </div>
        </div>
      </div>
  </div> -->



    <form [formGroup]="commentForm">
      <!-- <div class="mb-4 mt-3 editor-container" [class.readonly-editor]="isEditorDisabled">
        <label class="mb-2 d-block">
          Comments
        </label>
      
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div> -->
      <div class="editor-field">
        <b class="form-label-left">Comment</b>
        <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      </div>
    </form>
  </div>
</div>